/** @jsx jsx */
import { jsx } from "@emotion/react";

import useBooleanState from "../../../../../hooks/utils/useBooleanState";
import User2NotificationsModal from "../../../../molecules/modals/User2NotificationsModal";
import { SettingsIcon } from "./CardList/styles";
import { useUserId } from "../../../../../store/login/hooks/useSelectors";

const useSettingsModal = () => {
  const userId = useUserId();
  const [isOpen, toggleOpen] = useBooleanState(false);

  const modal = (
    <User2NotificationsModal
      isOpen={isOpen}
      toggleOpen={toggleOpen}
      userId={userId ?? 0}
    />
  );

  const modalToggle = (
    <SettingsIcon onClick={toggleOpen} data-cy="settings-image" />
  );

  return [modal, modalToggle] as const;
};

export default useSettingsModal;
